import React, { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  Offcanvas,
  OffcanvasBody,
  ButtonGroup,
  Label,
} from "reactstrap";
import { Container, Row, Button, Col, FormGroup, Input } from "reactstrap";

import ArrowRight from "assets/icon/arrow-right-purple.svg";
import { useLocation, useNavigate } from "react-router-dom";
import patientsScanImage from "assets/images/patients-scan.svg";
import doubleArrow from "assets/icon/double-arrow-down.svg";
import Checkbox from "components/common/Fields/Checkbox";
import columnSelectorIcon from "../../../../../assets/icon/column-selector.svg";
import editIocn from "../../../../../assets/inventory/edit-icon.svg";
import deleteIcon from "../../../../../assets/inventory/delete-icon.svg";
import CloseIcon from "../../../../../assets/icon/chatClose.svg";
import greenCircle from "../../../../../assets/icon/status-green-circle.svg";
import redCircle from "../../../../../assets/icon/red-status-icon.svg";
import leftArrow from "../../../../../assets/icon/left-arrow.svg";
import SearchButtons from "components/SearchButtons";
import ReactStrapTable from "components/reactStrapTable";
import MoreDetails from "../MoreDetails/Index";
import refreshIcon from "../../../../../assets/icon/refresh-purple.svg";
import DrugName from "components/DrugName";

const OnOrderQueueDetails = () => {
  const navigate = useNavigate();

  const [open, setOpen] = useState("onorders");
  const [editDetails, setEditDetails] = useState(false);
  const [showPatientsDetails, setPatientsDetails] = useState(false);
  const [refreshBtn, setRefreshBtn] = useState(false);
  const [rSelected, setRSelected] = useState("off");
   const [tableData, setTableData] = useState(rowData);
        const [data, setData] = useState([]);

  const location = useLocation();
  const rowDatas = location.state;

  const togglebtn = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };
  const togglePatientsDetails = () => {
    setPatientsDetails(!showPatientsDetails);
  };

  const handleRowClick = () => {
    setEditDetails(true);
  };

  const columnData = [
    {
      id: "1",
      dataField: "all",
      text: (
        <span className="d-flex justify-content-start align-items-center gap-2">
          <Checkbox /> All
        </span>
      ),
      show: true,
      width: 20,
    },
    {
      id: 8,
      dataField: "status",
      text: "Status",
      show: true,
      sort: true,
      width: 80,
    },
    {
      id: "2",
      dataField: "exceptions",
      text: "Exceptions",
      show: true,
      // sort: true,
      width: 150,
    },

    {
      id: "6",
      dataField: "drugname",
      text: "Drug Name",
      show: true,
      width: 150,
      sort: true,
      cellRenderer: (rowData) => DrugName(rowData),
    },

    {
      id: "7",
      dataField: "npcupc",
      text: "NDC/UPC",
      show: true,
      width: 80,
      sort: true,
    },
    {
      id: "8",
      dataField: "manufacturer",
      text: "Manufacturer",
      show: true,
      width: 120,
      sort: true,
      // cellRenderer: (rowData) => (
      //   <div onClick={() => setEditDetails(!editDetails)}>
      //     {rowData.manufacturer}
      //   </div>
      // ),
    },
    {
      id: "9",
      dataField: "orderqty",
      text: "Order QTY",
      show: true,
      width: 120,
      sort: true,
    },
    {
      id: "10",
      dataField: "shippedqty",
      text: "Shipped QTY",
      show: true,
      width: 120,
      sort: true,
    },
  ];

  const rowData = [
    {id:2,
      all: (
        <div>
          <Checkbox />
        </div>
      ),
      status: <img src={greenCircle} />,
      exceptions: "-",
      drugname: "Lisinopril 10mg Tablet (1000 EA/BTL)",
      npcupc: "34981319899",
      manufacturer: "Lupin",
      orderqty: "10 BTL",
      shippedqty: "10 BTL",
    },
    {id:3,
      all: (
        <div>
          <Checkbox />
        </div>
      ),
      status: <img src={greenCircle} />,
      exceptions: "Limited DC availablity",
      drugname: "Metformin 500mg Tablet",
      npcupc: "42415977579",
      manufacturer: "Amneal",
      orderqty: "5 BTL",
      shippedqty: "10 BTL",
    },
    {
      id:4,
      all: (
        <div>
          <Checkbox />
        </div>
      ),
      status: <img src={greenCircle} />,
      exceptions: "-",
      drugname: "Amlodipine 5mg Tablet",
      npcupc: "38613370164",
      manufacturer: "Alembic",
      orderqty: "8 BTL",
      shippedqty: "10 BTL",
    },
    {
      id:5,
      all: (
        <div>
          <Checkbox />
        </div>
      ),
      status: <img src={greenCircle} />,
      exceptions: "-",
      drugname: "Omeprazole 20mg Capsule",
      npcupc: "48548142434",
      manufacturer: "Northstar",
      orderqty: "3 BTL",
      shippedqty: "10 BTL",
    },
    {
      id:6,
      all: (
        <div>
          <Checkbox />
        </div>
      ),
      status: <img src={greenCircle} />,
      exceptions: "Substituted Eqv.NDC",
      drugname: "Gabapentin 300mg Capsule",
      npcupc: "92497230725",
      manufacturer: "Accord",
      orderqty: "5 BTL",
      shippedqty: "5 BTL",
    },
    {
      id:7,
      all: (
        <div>
          <Checkbox />
        </div>
      ),
      status: <img src={greenCircle} />,
      exceptions: "-",
      drugname: "Simvastatin 20mg Tablet ",
      npcupc: "95757803602",
      manufacturer: "Teva",
      orderqty: "4 BTL",
      shippedqty: "4 BTL",
    },
    {
      id:8,
      all: (
        <div>
          <Checkbox />
        </div>
      ),
      status: <img src={greenCircle} />,
      exceptions: "-",
      drugname: "Sertraline 50mg Tablet",
      npcupc: "79889412208",
      manufacturer: "Rising",
      orderqty: "3 BTL",
      shippedqty: "3 BTL",
    },
    { id:90,
      all: (
        <div>
          <Checkbox />
        </div>
      ),
      status: <img src={greenCircle} />,
      exceptions: "-",
      drugname: "Pantoprazole 40mg Tablet",
      npcupc: "39638933844",
      manufacturer: "Rising",
      orderqty: "2 BTL",
      shippedqty: "2 BTL",
    },
    {id:100,
      all: (
        <div>
          <Checkbox />
        </div>
      ),
      status: <img src={greenCircle} />,
      exceptions: "-",
      drugname: "Metoprolol Tartrate 25mg Tablet",
      npcupc: "55902480611",
      manufacturer: "Alembic",
      orderqty: "2 BTL",
      shippedqty: "1 BTL",
    },
  
  ];


  const handleRefresh = () => {
    setRefreshBtn(true);
    setTimeout(() => {
      setRefreshBtn(false);
    }, 2000);
  };

  const toggleFilter = () => {
    setRSelected((prev) => (prev === "off" ? "on" : "off"));
  };

  return (
    <div className="bg-white p-3 mb-2 table-card scroll-table position-relative layout-alignment border-0 rounded bg-white pb-0">
      {refreshBtn && (
        <div className="refresh-bgv">
          <img className="rotate-img" src={refreshIcon} width={40} />
        </div>
      )}
      <Container
        fluid
        className="d-flex justify-content-start align-items-center mb-1 pb-2 gap-2 section-devider-border"
      >
        <img
          src={leftArrow}
          className="cursor-pointer left-arrow-btn"
          onClick={() => navigate(-1)}
        />
        <div className="heading-text">Order Details</div>
      </Container>
      <div>
        <Container fluid>
          <div className="border mb-2 p-6 bg-white bx-shadow">
            <Row>
                <h3 className="patient-demo " onClick={togglePatientsDetails}>
                  Vendor Details
                  <span>
                    {showPatientsDetails ? (
                      <><img
                        src={doubleArrow}
                        style={{
                          transform: "rotate(180deg)",
                          transition: "opacity 0.3s ease, transform 0.3s ease",
                            marginLeft: "12px",    verticalAlign: "middle"
                        }}
                      />
                      <div style={{borderBottom:"1px solid #D3D3D3", marginTop:"8px"}}></div>
                      </>
                    ) : (
                      <img
                        src={doubleArrow}
                        style={{ transition: "opacity 0.3s ease",
                          marginLeft: "12px",    verticalAlign: "middle" }}
                      />
                    )}
                    
                  </span>
                </h3>
                {showPatientsDetails ? (
                  <Row>
                    <div  className="d-flex justify-content-between " 
                    >
                      <div>
                        <div class="pdetails">Wholesaler</div>
                        <div className="patient-details">
                          {rowDatas.mfgValue}
                        </div>
                      </div>
                      <div>
                        <div class="pdetails">Order Number</div>
                        <div className="patient-details">MCK-2025012801</div>
                      </div>
                      <div>
                        <div className="pdetails ">Order Date</div>
                        <div className="patient-details">20/01/2025</div>
                      </div>
                      <div>
                        <div className="pdetails">Total Items</div>
                        <div className="patient-details">12</div>
                      </div>
                      </div>
                      <div
                        className="d-flex justify-content-between mt-2"
                      >
                        <div>
                          <div className="pdetails ">Ship Date</div>
                          <div className="patient-details">21/01/2025</div>
                        </div>
                        <div>
                          <div className="pdetails ">PO Memo</div>
                          <div className="patient-details">
                            Weekly Stock Order
                          </div>
                        </div>
                        <div>
                          <div className="pdetails ">Order Confirmation</div>
                          <div className="patient-details">CNF-7724691</div>
                        </div>
                        <div>
                          <div className="pdetails ">Total Packages</div>
                          <div className="patient-details">43</div>
                        </div>
                      </div>
                 
                      <div className="d-flex justify-content-between  mt-2">
                        <div>
                          <div className="pdetails ">Total Cost</div>
                          <div className="patient-details">$ 2,752.95</div>
                        </div>
                        <div>
                          <div className="pdetails ">Exceptions</div>
                          <div className="patient-details">3</div>
                        </div>
                        <div>
                          <div className="pdetails"></div>
                          <div className="patient-details"></div>
                        </div>
                        <div>
                          <div className="pdetails "></div>
                          <div className="patient-details"></div>
                        </div>
                      </div>
                  </Row>
                ) : (
                  <div className="d-flex justify-content-between">
                    <div>
                      <span class="pdetails">Wholesaler: </span>
                      <span className="patient-details">
                        {rowDatas.mfgValue}
                      </span>
                    </div>

                    <div>
                      <span className="pdetails purple-border-left ">
                        Order Number:{" "}
                      </span>
                      <span className="patient-details">MCK-2025012801</span>
                    </div>

                    <div>
                      <span className="pdetails purple-border-left ">
                        Order Date:
                      </span>
                      <span className="patient-details">01/20/2025</span>
                    </div>
                    <div>
                      <span className="pdetails purple-border-left ">
                        Ship Date:{" "}
                      </span>
                      <span className="patient-details">21/01/2025</span>
                    </div>
                    <div>
                      <span className="pdetails purple-border-left">
                        Total Items:{" "}
                      </span>
                      <span className="patient-details">
                        {rowDatas.itemOrdered}
                      </span>
                    </div>
                  </div>
                )}
            </Row>
          </div>
        </Container>
        <Container fluid>
        <div fixed-height={rowData.length > 0 ? "fixed-height" : "default"}>

          <div className="table-card scroll-table position-relative border-0 pt-0 rounded bg-white">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{ display: "flex", gap: "6px", alignItems: "center" }}
              >
                <div>
                  {" "}
                  <Label style={{ color: "#702C62" }}>Product Details</Label>
                </div>
                <div>
                  <SearchButtons
                    InSize={250}
                    placeHolder={"Search by Product name"}
                    data={data}
                    setFilterData={setTableData}
                  />
                </div>
                <div>
                  <Dropdown isOpen={undefined} toggle={undefined}>
                    <DropdownToggle className="clmn">
                      <img src={columnSelectorIcon} alt="not available" />
                      <span>
                        Columns{" "}
                        {/* {totalCount > 0 && (
                                    <div className="totalcount">{totalCount}</div>
                                  )} */}
                      </span>
                    </DropdownToggle>
                  </Dropdown>
                </div>
                <div className="d-flex justify-content-center align-items-center gap-2">
                  <span className="f-16 font-weight-600">Filter</span>
                  <ButtonGroup className="filter-btn-group">
                    <Button
                      color="info"
                      outline
                      onClick={toggleFilter}
                      active={rSelected === "off"}
                    >
                      OFF
                    </Button>
                    <Button
                      color="info"
                      outline
                      active={rSelected === "on"}
                      onClick={toggleFilter}
                    >
                      ON
                    </Button>
                  </ButtonGroup>
                </div>
              </div>
              <div className="d-flex">
                <Button color="tranparent" disabled className="back-button">
                  {" "}
                  Update Order Status
                </Button>
                <Button color="primary" onClick={handleRefresh}>
                  {" "}
                  Refresh
                </Button>
              </div>
            </div>
            <div fixed-height={rowData.length > 0 ? "fixed-height" : "default"}>
              <ReactStrapTable
                id="order-quee-details"
                columns={columnData}
                data={rowData}
                enablerowRouting={true}
                handleRowClick={handleRowClick}
              />
            </div>
          </div>
          </div>
        </Container>
        <div>
          <Offcanvas
            direction="end"
            isOpen={editDetails}
            toggle={() => setEditDetails(!editDetails)}
          >
            <div className="casvas-header p-3 pb-2">
              <div>More Details</div>
              <div
                className="cursor-pointer"
                onClick={() => setEditDetails(!editDetails)}
              >
                <img src={CloseIcon} />
              </div>
            </div>
            <div className="border-canvas"></div>
            <div className="section-devider-border-popup mb-3"></div>
            
            <OffcanvasBody className="p-4 pt-1">
              <MoreDetails data={rowDatas} />
            
            </OffcanvasBody>
            <div className="footer-btns">
              <div></div>
              <div className="d-flex">
                <Button color="primary" className="reset"  onClick={() => setEditDetails(false)} >
                  Back
                </Button>
                <Button color="primary">Refresh</Button>
              </div>
            </div>
          </Offcanvas>
        </div>
      </div>
    </div>
  );
};
export default OnOrderQueueDetails;
